module.exports = __webpack_public_path__ + "files/4e2efc1b6e3552d5e8b87ca449dec8d3.png";